import { render, staticRenderFns } from "./VehicleCarryWeightSelect.vue?vue&type=template&id=5d4070c2&lang=pug"
import script from "./VehicleCarryWeightSelect.vue?vue&type=script&lang=js"
export * from "./VehicleCarryWeightSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports